import { combineReducers } from 'redux';

import activateUtr from './activateUtrReducer';
import allMatches from './allMatchReducer';
import auth from './authReducer';
import club from './clubReducer';
import clubLocation from './clubLocationReducer';
import componentConfig from './componentConfigReducer';
import coreUI from './coreUIReducer';
import courtScheduler from './courtSchedulerReducer';
import dashboard from './dashboardReducer';
import dayPlanner from './dayPlannerReducer';
import drawEdit from './drawEditReducer';
import dualMatch from './dualMatchReducer';
import eventProfile from './eventProfileReducer';
import events from './eventsReducer';
import eventTemplates from './eventTemplatesReducer';
import explore from './exploreReducer';
import featuredMatches from './featuredMatchesReducer';
import getRated from './getRatedReducer';
import group from './groupReducer';
import header from './headerReducer';
import homepage from './homepageReducer';
import importedLeague from './importedLeagueReducer';
import importedTournament from './importedTournamentReducer';
import leagues from './leaguesReducer';
import loginPopUp from './loginPopUpReducer';
import manageLists from './manageListsReducer';
import matchedProfiles from './matchedProfilesReducer';
import menu from './menuReducer';
import messaging from './messagingReducer';
import naturalSearch from './naturalSearchReducer';
import nextAvailable from './nextAvailableReducer';
import notifications from './notificationsReducer';
import oauth from './oauthReducer';
import onboarding from './onboardingReducer';
import popups from './popupsReducer';
import postScore from './postScoreReducer';
import prismic from './prismicReducer';
import profile from './profileReducer';
import profileTabData from './profileTabReducer';
import progressBar from './progressBarReducer';
import resources from './resourcesReducer';
import savedLists from './savedListsReducer';
import search from './searchReducer';
import splash from './splashReducer';
import statsig from './statsigReducer';
import subscribe from './subscribeReducer';
import topPlayers from './topPlayersReducer';
import tournamentContent from './tournamentContentReducer';
import trialAvailability from './trialAvailabilityReducer';
import upgradePopup from './upgradeToPowerReducer';
import uploads from './uploadReducer';

export default combineReducers({
    activateUtr,
    allMatches,
    auth,
    club,
    clubLocation,
    componentConfig,
    coreUI,
    courtScheduler,
    dashboard,
    dayPlanner,
    drawEdit,
    dualMatch,
    eventProfile,
    events,
    eventTemplates,
    explore,
    featuredMatches,
    getRated,
    group,
    header,
    homepage,
    importedLeague,
    importedTournament,
    leagues,
    loginPopUp,
    manageLists,
    matchedProfiles,
    menu,
    messaging,
    naturalSearch,
    nextAvailable,
    notifications,
    oauth,
    onboarding,
    popups,
    postScore,
    prismic,
    profile,
    profileTabData,
    progressBar,
    resources,
    savedLists,
    search,
    splash,
    statsig,
    subscribe,
    topPlayers,
    tournamentContent,
    trialAvailability,
    upgradePopup,
    uploads,
});
